import Header from '../components/Header';

function Quiz() {
  return <>
    <Header />

    <div id="tiles">
        <a id="nov17" className="link" href="/nov.html">
            <span>17. november</span>
        </a>
    </div>
  </>
}

export default Quiz;